<!-- 查看成绩权限 -->
<template>
  <div class="el-ScoreWeight">
    <el-row class="content_block mb20">
      <TitleInfo title="查看成绩权限" :titleImg="cjqz"></TitleInfo>
      <el-row class="m20">
        <el-col :span="24">
          <el-row class="scoreInfo">
            <TitleInfo title="总成绩权重" bgClose="#EFF2F7" :showClose="false" :titleImg="zongcj"></TitleInfo>
            <el-row class="p20 font12">
              总成绩=
              <el-input v-model="form.signInResult" style="width: 50px;"></el-input> x
              签到成绩 +
              <el-input v-model="form.chapterContactResult" style="width: 50px;"></el-input> x
              章节练习成绩 +
              <el-input v-model="form.coursePracticeResult" style="width: 50px;"></el-input> x
              课程实操成绩 +
              <el-input v-model="form.homeworkResult" style="width: 50px;"></el-input> x
              作业成绩 +
              <el-input v-model="form.examinationResult" style="width: 50px;"></el-input> x
              考试成绩 +
              <el-input v-model="form.interactionResult" style="width: 50px;"></el-input> x
              互动成绩
            </el-row>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="m20">
        <el-col :span="12">
          <el-row class="scoreInfo">
            <TitleInfo title="签到成绩权重" bgClose="#EFF2F7" :showClose="false" :titleImg="qd"></TitleInfo>
            <el-row class="p20 font12">
              <el-radio v-model="form.signInResultSetting" label="1">
                按签到次数计分：签到一次
                <el-input v-model="form.signInScore" style="width: 50px;"></el-input>
                分
              </el-radio>
              <el-radio v-model="form.signInResultSetting" label="2">
                按到课率计分：签到总次数 / 总考勤次数 * 100
              </el-radio>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row class="scoreInfo">
            <TitleInfo title="互动成绩权限" bgClose="#EFF2F7" :showClose="false" :titleImg="hdcj"></TitleInfo>
            <el-row class="p20 font12">
              <el-checkbox v-model="interactionResultSettingList" label="1">
                每留言一次
                <el-input v-model="form.interactionResultMessageScore" style="width: 50px;"></el-input>
                分
              </el-checkbox>
              <el-checkbox v-model="interactionResultSettingList" label="2">
                每提问一次
                <el-input v-model="form.interactionResultQuestionScore" style="width: 50px;"></el-input>
                分
              </el-checkbox>
              <el-checkbox v-model="interactionResultSettingList" label="3">
                每回答问题一次
                <el-input v-model="form.interactionResultAnswerScore" style="width: 50px;"></el-input>
                分
              </el-checkbox>
            </el-row>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="m20">
        <el-col :span="12">
          <el-row class="scoreInfo">
            <TitleInfo title="课程实操成绩权重" bgClose="#EFF2F7" :showClose="false" :titleImg="kcsc"></TitleInfo>
            <el-row class="p20 font12">
              <el-radio v-model="form.coursePracticeResultSetting" label="1">
                按得分计分：平均得分
              </el-radio>
              <el-radio v-model="form.coursePracticeResultSetting" label="2">
                按完成进度计分：平均完成进度 * 100
              </el-radio>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row class="scoreInfo">
            <TitleInfo title="章节练习成绩权重" bgClose="#EFF2F7" :showClose="false" :titleImg="zjlx"></TitleInfo>
            <el-row class="p20 font12">
              <el-radio v-model="form.chapterContactResultSetting" label="1">
                按正确率计分：平均正确率 * 100%
              </el-radio>
              <el-radio v-model="form.chapterContactResultSetting" label="2">
                按完成进度计分：平均完成进度 * 100
              </el-radio>
            </el-row>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="m20">
        <el-col :span="12">
          <el-row class="scoreInfo">
            <TitleInfo title="考试成绩权限" bgClose="#EFF2F7" :showClose="false" :titleImg="kscj"></TitleInfo>
            <el-row class="p20 font12">
              <el-radio v-model="form.examinationResultSetting" label="1">
                按得分计分：平均得分
              </el-radio>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row class="scoreInfo">
            <TitleInfo title="作业成绩权限" bgClose="#EFF2F7" :showClose="false" :titleImg="zycj"></TitleInfo>
            <el-row class="p20 font12">
              <el-radio v-model="form.homeworkResultSetting" label="1">
                按得分计分：平均得分
              </el-radio>
            </el-row>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="m20">
        <el-row class="scoreInfo pb20">
          <TitleInfo title="成绩状态" bgClose="#EFF2F7" :showClose="false" :titleImg="cjzt"></TitleInfo>
          <el-row class="pl20 pt20 font12">
            <el-radio class="mr10" v-model="form.resultStatusSetting" label="1">二分法：</el-radio>
            <el-input v-model="form.dichotomyScore" style="width: 50px;"></el-input>
            分以上为及格，以下为不及格
          </el-row>
          <el-row class="pl20 pt20 font12">
            <el-radio class="mr10" v-model="form.resultStatusSetting" label="2">等级法：</el-radio>
            优秀 <el-input v-model="form.excellentScore" style="width: 50px;"></el-input> 分以上；
            良好 <el-input v-model="form.goodScore" style="width: 50px;"></el-input> 分以上；
            中等 <el-input v-model="form.secondaryScore" style="width: 50px;"></el-input> 分以上；
            及格 <el-input v-model="form.passScore" style="width: 50px;"></el-input> 分以上；
            其余不及格
          </el-row>
          <el-row class="pl20 pt20 font12">
            <el-radio class="mr10" v-model="form.resultStatusSetting" label="3">字母法：</el-radio>
            A <el-input v-model="form.letteraScore" style="width: 50px;"></el-input> 分以上；
            B <el-input v-model="form.letterbScore" style="width: 50px;"></el-input> 分以上；
            C <el-input v-model="form.lettercScore" style="width: 50px;"></el-input> 分以上；
            D <el-input v-model="form.letterdScore" style="width: 50px;"></el-input> 分以上；
            其余为E
          </el-row>
        </el-row>
      </el-row>
      <el-row class="mt20 mr40 mb20 t_r">
        <el-button type="primary" @click="submitInfo">确定</el-button>
        <el-button @click="$router.go(-1);">返回</el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部

export default {
  name: "ScoreWeight",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      cjqz:require("../../images/course/cjqz@2x.png"),
      cjzt:require("../../images/course/cjzt@2x.png"),
      hdcj:require("../../images/course/hdcj@2x.png"),
      kcsc:require("../../images/course/kcsc@2x.png"),
      kscj:require("../../images/course/kscj@2x.png"),
      qd:require("../../images/course/qd@2x.png"),
      zjlx:require("../../images/course/zjlx@2x.png"),
      zongcj:require("../../images/course/zongcj@2x.png"),
      zycj:require("../../images/course/zycj@2x.png"),
      form:{
        signInResultSetting:"1", //签到成绩设置1签到次数2到课到率
        chapterContactResultSetting:"1", //章节联系设置1正确率积分2平均完成度计分
        coursePracticeResultSetting:"1", //课程实操成绩设置1平均分2平均完成进度
        homeworkResultSetting:"1", //作业成绩设置1平均分(默认1)
        examinationResultSetting:"1", //考试成绩设置1平均分(默认1)
        resultStatusSetting:"1", //成绩状态设置1二分法2等级法3字母法
      },
      interactionResultSettingList:['1'], //互动成绩设置1留言2提问3回答
      url:"/api/teacherOpenCourseScoreWeight/add.do",
      teacherOpenCourseId:this.$route.query.courseId
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    getInfo(){
      this.$get("/api/teacherOpenCourseScoreWeight/getInfo.do",{teacherOpenCourseId:this.teacherOpenCourseId}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.form = ret.data;
            if(!this.$isEmpty(ret.data.interactionResultSetting)){
              this.interactionResultSettingList = ret.data.interactionResultSetting.split(",");
            }
            this.url = "/api/teacherOpenCourseScoreWeight/update.do";
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    submitInfo(){ //提交数据
      if(this.$isEmpty(this.form.signInResult)){
        this.$message.warning("请输入签到成绩(总成绩权重)");
        return;
      }
      if(this.$isEmpty(this.form.chapterContactResult)){
        this.$message.warning("请输入章节练习成绩(总成绩权重)");
        return;
      }
      if(this.$isEmpty(this.form.coursePracticeResult)){
        this.$message.warning("请输入课程实操成绩(总成绩权重)");
        return;
      }
      if(this.$isEmpty(this.form.homeworkResult)){
        this.$message.warning("请输入作业成绩(总成绩权重)");
        return;
      }
      if(this.$isEmpty(this.form.examinationResult)){
        this.$message.warning("请输入考试成绩(总成绩权重)");
        return;
      }
      if(this.$isEmpty(this.form.interactionResult)){
        this.$message.warning("请输入互动成绩(总成绩权重)");
        return;
      }
      let result = Number(this.form.signInResult) + Number(this.form.chapterContactResult) +
                  Number(this.form.coursePracticeResult) + Number(this.form.homeworkResult) +
                  Number(this.form.examinationResult) + Number(this.form.interactionResult);
      if(result.toFixed(2) > 1){
        this.$message.warning("总成绩权重总和不能大于1");
        return;
      }

      if(this.form.signInResultSetting == 1){ //签到成绩设置1签到次数2到课到率
        if(this.$isEmpty(this.form.signInScore)){
          this.$message.warning("请输入每签到一次分数");
          return;
        }
      }
      if(this.interactionResultSettingList.length > 0){ //互动成绩设置1留言2提问3回答
        this.form.interactionResultSetting = this.interactionResultSettingList.join(",");
        if(this.form.interactionResultSetting.indexOf("1") >= 0){
          if(this.$isEmpty(this.form.interactionResultMessageScore)){
            this.$message.warning("请输入互动成绩留言得分");
            return;
          }
        }
        if(this.form.interactionResultSetting.indexOf("2") >= 0){
          if(this.$isEmpty(this.form.interactionResultQuestionScore)){
            this.$message.warning("请输入互动成绩提问得分");
            return;
          }
        }
        if(this.form.interactionResultSetting.indexOf("3") >= 0){
          if(this.$isEmpty(this.form.interactionResultAnswerScore)){
            this.$message.warning("请输入互动成绩回答得分");
            return;
          }
        }
      }

      if(this.form.resultStatusSetting == 1){ //成绩状态设置1二分法2等级法3字母法
        if(this.$isEmpty(this.form.dichotomyScore)){
          this.$message.warning("请输入二分法分数");
          return;
        }
      }else if(this.form.resultStatusSetting == 2){
        if(this.$isEmpty(this.form.excellentScore)){
          this.$message.warning("请输入等级法优秀分数");
          return;
        }
        if(this.$isEmpty(this.form.goodScore)){
          this.$message.warning("请输入等级法良好分数");
          return;
        }
        if(this.$isEmpty(this.form.secondaryScore)){
          this.$message.warning("请输入等级法中等分数");
          return;
        }
        if(this.$isEmpty(this.form.passScore)){
          this.$message.warning("请输入等级法及格分数");
          return;
        }
      }else if(this.form.resultStatusSetting == 3){
        if(this.$isEmpty(this.form.letteraScore)){
          this.$message.warning("请输入字母法A分数");
          return;
        }
        if(this.$isEmpty(this.form.letterbScore)){
          this.$message.warning("请输入字母法B分数");
          return;
        }
        if(this.$isEmpty(this.form.lettercScore)){
          this.$message.warning("请输入字母法C分数");
          return;
        }
        if(this.$isEmpty(this.form.letterdScore)){
          this.$message.warning("请输入字母法D分数");
          return;
        }
      }
      this.form.teacherOpenCourseId = this.teacherOpenCourseId;
      this.$post(this.url,this.form).then((ret) =>{
        if(ret.code == 0){
          this.$message({type: 'success',message: '操作成功！'});
          this.url = "/api/teacherOpenCourseScoreWeight/update.do";
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-ScoreWeight{
    padding: 20px 20px 0;
    .content_block{
      min-height: calc(100vh - 140px);
      background-color: #ffffff;
      .scoreInfo{
        border: 1px solid #D3D3D3;
        margin-right: 20px;
      }
    }
    .el-input__inner{
      padding: 0;
      text-align: center;
    }
    .el-input{
      margin: 0 5px;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/ScoreWeight.vue